import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArConnectApiKeyPublishedNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArConnectApiKeyPublishedNotifyFollowers: TemplateDefinition<ArConnectApiKeyPublishedNotifyFollowersProps> =
  {
    renderParams: (props: ArConnectApiKeyPublishedNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arConnectApiKeyPublishedNotifyFollowers',
      values: {
        apiKeyName: props?.request?.name,
      },
    }),
  }
